import { getDaysInMonth } from "date-fns";

export const generateDayOptions = (month: string, year?: number) => {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  const selectedYear = year || new Date().getFullYear();
  const daysInMonth = getDaysInMonth(
    new Date(Number(selectedYear), Number(month) - 1),
  );
  return Array.from({ length: daysInMonth }, (_, i) => {
    const day = String(i + 1).padStart(2, "0");
    return { value: day, label: day };
  });
};
